import React, { useState } from "react";
import "../Styles/emlak-genel.css";

const RbaMapComponent = () => {
  // Hangi şubenin aktif olduğunu takip eden state
  const [activeBranch, setActiveBranch] = useState("odunpazari");

  // Harita URL'leri
  const mapUrls = {
    deliklitas:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1671!2d30.5213153!3d39.7685384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cc1603bc679897%3A0x84670b9962a6990!2sRBA%20Gayrimenkul!5e0!3m2!1str!2str!4v1642869952544!5m2!1str!2str",
    odunpazari:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.936603994165!2d30.5276826!3d39.7700965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cc3d003d5b1ed7%3A0x9362d4c3f7b369aa!2sRba%20Emlak!5e0!3m2!1str!2str!4v1710000000000",
  };

  // Harita değiştirme fonksiyonu
  const changeMap = (branch) => {
    setActiveBranch(branch);
  };

  return (
    <div className="rba-about-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 p-0">
            <div className="rba-map-container-left">
              <iframe
                src={mapUrls[activeBranch]}
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: "10px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="RBA Gayrimenkul Şube Haritası"
              ></iframe>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="rba-content">
              <h6 className="rba-subtitle">| HAKKIMIZDA</h6>
              <h2 className="rba-title">RBA Gayrimenkul</h2>
              <p className="rba-description">
                Gayrimenkul sektöründe güvenilir hizmetin adresi olan RBA
                Gayrimenkul, alım, satım, kiralama ve iş takibi konularında
                uzman kadrosuyla Eskişehir in iki farklı lokasyonunda hizmet
                vermektedir.
              </p>

              <div className="rba-branches">
                <div className="rba-branch-tabs">
                  <button
                    className={`rba-tab-btn ${
                      activeBranch === "odunpazari" ? "active" : ""
                    }`}
                    onClick={() => changeMap("odunpazari")}
                  >
                    <div className="rba-icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                    </div>
                    <div className="rba-tab-info">
                      <h5>Vatan Caddesi Şubemiz</h5>
                      <p>
                        Kurtuluş, Vatan Cd. No:43 26090 Odunpazarı, Eskişehir
                      </p>
                    </div>
                  </button>
                  <button
                    className={`rba-tab-btn ${
                      activeBranch === "deliklitas" ? "active" : ""
                    }`}
                    onClick={() => changeMap("deliklitas")}
                  >
                    <div className="rba-icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                    </div>
                    <div className="rba-tab-info">
                      <h5>Deliklitaş Şubemiz</h5>
                      <p>
                        Deliklitaş Mahallesi, Deliklitaş Cd. No:22 Odunpazarı,
                        Eskişehir
                      </p>
                    </div>
                  </button>
                </div>
              </div>

              <div className="rba-services-tags">
                <span className="rba-tag">Gayrimenkul Alım Satım</span>
                <span className="rba-tag">Kiralama</span>
                <span className="rba-tag">İş Takibi</span>
                <span className="rba-tag">Güvenli Yatırım</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RbaMapComponent;
